module.exports = __webpack_public_path__ + "img/OverseaMember51.483e3061.jpg";